module.exports = {
    NODE_ENV: "production",
    BROWSER: true,
    API_ENDPOINT: "https://msm.api.educrm.vn/api",
};
